import React, { useEffect, useState, useRef } from 'react';
import './materials.css';

import Aos from 'aos';
import 'aos/dist/aos.css';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { BsArrowLeft, BsArrowRight, BsArrowRightShort } from 'react-icons/bs';
import { config } from "../../config";
import Lightbox from './Lightbox';
import { useLocalized } from '../../i18n/useLocalized';

const Materials = () => {
  const { t } = useTranslation();
  const loc = useLocalized();
  const navigate = useNavigate();
  const [galleryData, setGalleryData] = useState(
      JSON.parse(localStorage.getItem('galleryData')) || []
  );
  const [currentIndex, setCurrentIndex] = useState(0);
  const [lightboxIndex, setLightboxIndex] = useState(null);
  const touchStartX = useRef(null);

  useEffect(() => {
    Aos.init({
      duration: 2000,
      once: true
    });

    const fetchGalleryData = async () => {
      try {
        const response = await fetch(`${config.baseUrl}/galeries`);
        const data = await response.json();

        // Always sync state; only rewrite localStorage when data changed
        setGalleryData(data);
        const storedData = JSON.parse(localStorage.getItem('galleryData')) || [];
        if (JSON.stringify(data) !== JSON.stringify(storedData)) {
          localStorage.setItem('galleryData', JSON.stringify(data));
        }
      } catch (error) {
        console.error('Error fetching gallery data:', error);
        // If fetch fails, keep existing localStorage data
      }
    };

    fetchGalleryData();
  }, []);

  const count = galleryData.length;

  const prev = () => setCurrentIndex((i) => (i - 1 + count) % count);
  const next = () => setCurrentIndex((i) => (i + 1) % count);

  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleTouchMove = (e) => {
    if (touchStartX.current === null || count < 2) return;
    const diffX = touchStartX.current - e.touches[0].clientX;
    if (Math.abs(diffX) > 50) {
      diffX > 0 ? next() : prev();
      touchStartX.current = null;
    }
  };

  const prevIndex = count > 0 ? (currentIndex - 1 + count) % count : 0;
  const nextIndex = count > 0 ? (currentIndex + 1) % count : 0;
  const current = galleryData[currentIndex];

  return (
      <div className="materials container section">
        <div className="sectionContainer">
          <div className="galleryHead" data-aos="fade-up">
            <span className="eyebrow">{t('gallery.eyebrow')}</span>
            <h2>{t('gallery.title')}</h2>
          </div>

          {count > 0 && (
              <div className="galleryCarousel" data-aos="fade-up">
                {count > 1 && (
                    <div className="peek peekLeft" onClick={prev} aria-hidden="true">
                      <img
                          src={galleryData[prevIndex].image}
                          alt={loc(galleryData[prevIndex], 'title')}
                      />
                    </div>
                )}

                <div
                    className="mainSlide"
                    onTouchStart={handleTouchStart}
                    onTouchMove={handleTouchMove}
                >
                  <img
                      key={current.id}
                      src={current.image}
                      alt={loc(current, 'title')}
                      onClick={() => setLightboxIndex(currentIndex)}
                  />
                  <span className="photoChip">{loc(current, 'title')}</span>

                  {count > 1 && (
                      <div className="carouselArrows">
                        <button onClick={prev} aria-label={t('gallery.prevImage')}>
                          <BsArrowLeft/>
                        </button>
                        <button onClick={next} aria-label={t('gallery.nextImage')}>
                          <BsArrowRight/>
                        </button>
                      </div>
                  )}
                </div>

                {count > 1 && (
                    <div className="peek peekRight" onClick={next} aria-hidden="true">
                      <img
                          src={galleryData[nextIndex].image}
                          alt={loc(galleryData[nextIndex], 'title')}
                      />
                    </div>
                )}
              </div>
          )}

          {count > 0 && (
              <h3 className="seeAll" onClick={() => navigate('/galerie')}>
                {t('gallery.seeAll')}
                <BsArrowRightShort className='iconSeeAll'/>
              </h3>
          )}
        </div>

        {lightboxIndex !== null && (
            <Lightbox
                items={galleryData}
                index={lightboxIndex}
                onClose={() => setLightboxIndex(null)}
                onNavigate={(dir) =>
                    setLightboxIndex((i) => (i + dir + count) % count)
                }
            />
        )}
      </div>
  );
};

export default Materials;
